/* MAIYKO EKLENTI — "Birlikte Seçelim" karar ağacı davranışı

   AĞAÇ: 1. adım her zaman ürün tipidir; tipin "dal" değeri sonraki
   adımları belirler.

     dal = "model"     -> model -> (beden) -> sonuç
     dal = "uyku"      -> sıcaklık -> kombin -> (beden) -> sonuç
     dal = "ayakkabi"  -> mevsim -> kategori -> cinsiyet -> (numara) -> sonuç
     dal = "beden"     -> (beden) -> sonuç

   Beden adımı dinamiktir: seçili tipin data-bedenler alanındaki
   "Etiket | tag" satırlarından kurulur, alan boşsa adım hiç gösterilmez.

   ÜRÜN GETİRME: her koleksiyon handle'ı için
   /collections/HANDLE/products.json?limit=100 çağrılır. Kombin iki
   handle taşıyorsa her koleksiyondan 2'şer, tek handle'da 4 ürün alınır.

   FİLTRELER: beden etiketi ve cinsiyet etiketi ürünün tags dizisinde,
   model "kelime" filtresi ürün başlığında aranır. Cinsiyet etiketi
   "kiz|unisex" gibi dikey çizgiyle ayrılmış VEYA listesi olabilir.

   FİLTRELER SERTTİR: kelime (model), cinsiyet, beden/numara ve stok
   asla gevşetilmez. Beden adımı yalnız stoklu bedenleri sunduğundan boş
   sonuç nadirdir; olursa sonuç ekranı stok-tükendi mesajını gösterir.

   Tema editörü: shopify:section:load bölümü yeniden kurar,
   shopify:block:select seçilen bloğun adımına atlar. */

(function () {
  'use strict';

  /* Koleksiyon başına tek istek — adımlar arası gidip gelirken tekrar çekilmez. */
  var onbellek = {};

  /* Dal başına adım sırası. "tip" hepsinin ortak köküdür. */
  var DAL_SIRASI = {
    model: ['model', 'beden', 'sonuc'],
    uyku: ['sicaklik', 'kombin', 'beden', 'sonuc'],
    ayakkabi: ['mevsim', 'kategori', 'cinsiyet', 'beden', 'sonuc'],
    beden: ['beden', 'sonuc']
  };

  /* Türkçe güvenli küçültme: İ -> i, I -> ı. */
  function kucult(metin) {
    if (metin === null || metin === undefined) return '';
    return String(metin).replace(/İ/g, 'i').replace(/I/g, 'ı').toLowerCase().trim();
  }

  /* data attribute'taki JSON'u güvenle çözer. */
  function jsonCoz(ham, varsayilan) {
    if (!ham) return varsayilan;
    try {
      var v = JSON.parse(ham);
      return v === null || v === undefined ? varsayilan : v;
    } catch (e) {
      return varsayilan;
    }
  }

  /* "Etiket | tag | tag2 ..." satırlarını listeye çevirir. İkinciden
     sonraki parçalar OR adaylarıdır ("0-3 Ay | 0-3 Ay | 0-6 Ay" —
     battaniyelerin 0-6 Ay bedeni 0-3 Ay seçiminde de eşleşsin). */
  function bedenleriCoz(ham) {
    var liste = [];
    if (!ham) return liste;
    var satirlar = String(ham).split(/\r?\n/);
    for (var i = 0; i < satirlar.length; i++) {
      var s = satirlar[i].replace(/^\s+|\s+$/g, '');
      if (!s) continue;
      var p = s.split('|');
      var etiket = (p[0] || '').replace(/^\s+|\s+$/g, '');
      if (!etiket) continue;
      var adaylar = [];
      for (var j = 1; j < p.length; j++) {
        var aday = p[j].replace(/^\s+|\s+$/g, '');
        if (aday) adaylar.push(aday);
      }
      liste.push({
        etiket: etiket,
        tag: adaylar.join('|')
      });
    }
    return liste;
  }

  /* Etiket ürünün tags dizisinde var mı? Tam eşleşme ya da içerme.
     Aranan "kiz|unisex" biçiminde VEYA listesi olabilir. */
  function tagVar(tags, aranan) {
    var ham = kucult(aranan);
    if (!ham) return true;
    if (!tags || !tags.length) return false;
    var adaylar = ham.split('|');
    for (var a = 0; a < adaylar.length; a++) {
      var hedef = adaylar[a].replace(/^\s+|\s+$/g, '');
      if (!hedef) continue;
      for (var i = 0; i < tags.length; i++) {
        var t = kucult(tags[i]);
        if (t === hedef) return true;
        if (t.indexOf(hedef) !== -1) return true;
      }
    }
    return false;
  }

  /* Model dalındaki "kelime" filtresi ürün BAŞLIĞINDA aranır. */
  function baslikVar(baslik, kelime) {
    var k = kucult(kelime);
    if (!k) return true;
    return kucult(baslik).indexOf(k) !== -1;
  }

  function fiyatYaz(ham) {
    var s = parseFloat(ham);
    if (isNaN(s)) return '';
    try {
      return new Intl.NumberFormat('tr-TR', {
        style: 'currency',
        currency: 'TRY',
        minimumFractionDigits: 2
      }).format(s);
    } catch (e) {
      return s.toFixed(2).replace('.', ',') + ' ₺';
    }
  }

  /* routes.root_url '/' ya da '/tr' olabilir; sonuna tek eğik çizgi koy. */
  function kokDuzelt(yol) {
    var y = yol || '/';
    if (y.charAt(y.length - 1) !== '/') y += '/';
    return y;
  }

  function urunleriGetir(kokUrl, handle) {
    if (!handle) return Promise.resolve([]);
    if (onbellek[handle]) return Promise.resolve(onbellek[handle]);
    var url = kokDuzelt(kokUrl) + 'collections/' + encodeURIComponent(handle) + '/products.json?limit=100';
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (yanit) {
        if (!yanit.ok) throw new Error('HTTP ' + yanit.status);
        return yanit.json();
      })
      .then(function (veri) {
        var liste = (veri && veri.products) || [];
        onbellek[handle] = liste;
        return liste;
      })
      .catch(function () {
        return [];
      });
  }

  /* Stok: en az bir varyantı satılabilir olan ürün stokta sayılır.
     products.json 'available' alanını taşımıyorsa (beklenmez) fail-open. */
  function stokVar(u) {
    var v = u.variants;
    if (!v || !v.length) return true;
    for (var i = 0; i < v.length; i++) {
      if (v[i].available !== false) return true;
    }
    return false;
  }

  /* Beden VARYANT başlığında da aranır (ayakkabı numaraları: "19 (11 cm)",
     ay bedenleri: "0-3 Ay"). Aranan "a|b" biçiminde OR listesi olabilir.
     Başlangıç eşleşmesi + o varyantın stokta olması aranır. */
  function varyantVar(variants, aranan) {
    var ham = kucult(aranan);
    if (!ham || !variants || !variants.length) return false;
    var adaylar = ham.split('|');
    for (var a = 0; a < adaylar.length; a++) {
      var hedef = adaylar[a].replace(/^\s+|\s+$/g, '');
      if (!hedef) continue;
      for (var i = 0; i < variants.length; i++) {
        var t = kucult(variants[i].title);
        if (t.indexOf(hedef) === 0 && variants[i].available !== false) return true;
      }
    }
    return false;
  }

  /* Beden eşleşmesi: önce ürün tag'lerinde, yoksa varyant başlıklarında. */
  function bedenUyar(u, bedenTag) {
    if (!bedenTag) return true;
    if (tagVar(u.tags || [], bedenTag)) return true;
    return varyantVar(u.variants, bedenTag);
  }

  function filtrele(urunler, kelime, cinsTag, bedenTag) {
    return urunler.filter(function (u) {
      var tags = u.tags || [];
      if (!stokVar(u)) return false;
      if (kelime && !baslikVar(u.title, kelime)) return false;
      if (cinsTag && !tagVar(tags, cinsTag)) return false;
      if (bedenTag && !bedenUyar(u, bedenTag)) return false;
      return true;
    });
  }

  /* TÜM filtreler serttir: kelime (model), cinsiyet, beden/numara ve stok.
     Gevşetme YOK — "Kız Bebek + 19 Numara" seçene asla erkek ya da başka
     numara gösterilmez. Beden adımı zaten yalnız stoklu bedenleri sunduğu
     için boş sonuç nadirdir; olursa sonuç ekranı stok-tükendi mesajını
     gösterir (kullanıcı kuralı: stokta olmayan ASLA önerilmez). */
  function suz(urunler, kelime, cinsTag, bedenTag, hedef) {
    return filtrele(urunler, kelime, cinsTag, bedenTag);
  }

  function urunGorseli(urun) {
    if (urun.images && urun.images.length && urun.images[0].src) return urun.images[0].src;
    if (urun.image && urun.image.src) return urun.image.src;
    return '';
  }

  function urunFiyati(urun) {
    if (urun.price !== undefined && urun.price !== null) return urun.price;
    if (urun.variants && urun.variants.length) return urun.variants[0].price;
    return null;
  }

  /* ================= Sihirbaz kurulumu ================= */

  function kur(kok) {
    if (!kok || kok.__bsKuruldu) return;
    kok.__bsKuruldu = true;

    var kokUrl = kok.getAttribute('data-kok') || '/';
    var koleksiyonKok = kok.getAttribute('data-koleksiyon-kok') || '/collections';
    var varsayilanGorsel = kok.getAttribute('data-varsayilan-gorsel') || '';
    var fiyatGoster = kok.getAttribute('data-fiyat-goster') === '1';
    var bantVar = kok.getAttribute('data-bant-var') === '1';
    var genelModelSoru = kok.getAttribute('data-model-soru') || '';
    var metinYukleniyor = kok.getAttribute('data-metin-yukleniyor') || 'Yükleniyor…';
    var metinBos = kok.getAttribute('data-metin-bos') || '';
    var metinStok = kok.getAttribute('data-metin-stok') || 'Bu beden ve TOG değerinde stok şu an tükendi. Farklı bir beden ya da kombin deneyebilirsiniz.';

    var adimlar = kok.querySelectorAll('[data-bs-adim]');
    var oval = kok.querySelector('[data-bs-oval]');
    var gorselEl = kok.querySelector('[data-bs-gorsel]');
    var gridEl = kok.querySelector('[data-bs-grid]');
    var tumuEl = kok.querySelector('[data-bs-tumu]');
    var durumEl = kok.querySelector('[data-bs-durum]');
    var bedenKap = kok.querySelector('[data-bs-beden-kap]');
    var modelSoruEl = kok.querySelector('[data-bs-soru="model"]');

    var bosSecim = function () {
      return {
        dal: 'beden',
        tip: null,
        model: null,
        sicaklik: null,
        kombin: null,
        mevsim: null,
        kategori: null,
        cinsiyet: null,
        beden: null
      };
    };

    var secim = bosSecim();
    var bedenListesi = [];
    var gecmis = [];
    var aktif = 'tip';
    var istekNo = 0;

    /* ---------- Adım hazırlıkları (görünür seçenek sayısını döndürür) ---------- */

    /* Model adımı: yalnız seçili tipe ait model blokları görünür.
       tip_etiket boş bırakılmış blok (henüz ayarlanmamış) her zaman görünür. */
    function modelleriHazirla() {
      var hedefTip = secim.tip ? kucult(secim.tip.etiket) : '';
      var liste = kok.querySelectorAll('[data-bs-sec="model"]');
      var sayi = 0;
      for (var i = 0; i < liste.length; i++) {
        var sahip = kucult(liste[i].getAttribute('data-tip-etiket'));
        var uygun = !sahip || sahip === hedefTip;
        liste[i].hidden = !uygun;
        if (uygun) sayi++;
      }
      if (modelSoruEl) {
        var soru = (secim.tip && secim.tip.modelSoru) || genelModelSoru;
        if (soru) modelSoruEl.textContent = soru;
      }
      return sayi;
    }

    /* Kategori adımı: yalnız seçili mevsime uyan kategoriler görünür. */
    function kategorileriHazirla() {
      var mevsim = secim.mevsim ? secim.mevsim.deger : '';
      var liste = kok.querySelectorAll('[data-bs-sec="kategori"]');
      var sayi = 0;
      for (var i = 0; i < liste.length; i++) {
        var kapsam = liste[i].getAttribute('data-mevsimler') || 'hepsi';
        var uygun = !mevsim || kapsam === 'hepsi' || kapsam === mevsim;
        liste[i].hidden = !uygun;
        if (uygun) sayi++;
      }
      return sayi;
    }

    /* Kombin adımı: yalnız seçili bandın kapsayıcısı açılır. Banttaki tüm
       kombinler "Yakında" (pasif) ise bilgi notu gösterilir — kullanıcı
       takılmasın, Geri Dön ile başka aralık deneyebilsin. */
    function kombinleriHazirla() {
      var bant = secim.sicaklik ? secim.sicaklik.bant : '';
      var kaplar = kok.querySelectorAll('[data-bs-kombin-bant]');
      var notEl = kok.querySelector('[data-bs-kombin-not]');
      var sayi = 0;
      var aktifSayi = 0;
      for (var i = 0; i < kaplar.length; i++) {
        var bu = kaplar[i].getAttribute('data-bs-kombin-bant') === bant;
        kaplar[i].hidden = !bu;
        if (bu) {
          var hepsi = kaplar[i].querySelectorAll('[data-bs-sec="kombin"]');
          sayi = hepsi.length;
          for (var j = 0; j < hepsi.length; j++) {
            if (hepsi[j].getAttribute('data-pasif') !== '1') aktifSayi++;
          }
        }
      }
      if (notEl) notEl.hidden = !(sayi > 0 && aktifSayi === 0);
      return sayi;
    }

    /* Beden adımı: seçili tipin bedenler listesinden hap butonları kurar. */
    function bedenleriHazirla() {
      if (!bedenKap) return 0;
      bedenKap.innerHTML = '';
      for (var i = 0; i < bedenListesi.length; i++) {
        var b = bedenListesi[i];
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'maiyko-bs__sec';
        btn.setAttribute('data-bs-sec', 'beden');
        btn.setAttribute('data-tag', b.tag || '');
        btn.setAttribute('data-etiket', b.etiket);
        var yazi = document.createElement('span');
        yazi.className = 'maiyko-bs__secyazi';
        yazi.textContent = b.etiket;
        btn.appendChild(yazi);
        bedenKap.appendChild(btn);
      }
      return bedenListesi.length;
    }

    /* Beden adımı açılınca koleksiyon verisi çekilir ve KARŞILIĞI OLMAYAN
       bedenler gizlenir: seçili filtrelerle (kelime/cinsiyet) o bedende
       STOKLU ürün yoksa buton hiç gösterilmez. Veri gelene dek tüm
       butonlar görünür kalır; hepsi elenecekse hiçbiri gizlenmez
       (fail-open — sonuç ekranı zaten stok mesajını verir). */
    var bedenIstekNo = 0;
    function bedenleriSuz() {
      if (!bedenKap) return;
      var handleler = aktifHandleler();
      if (!handleler.length) return;
      var kelime = secim.dal === 'model' && secim.model ? secim.model.kelime : '';
      var cinsTag = secim.cinsiyet ? secim.cinsiyet.tag : '';
      /* Önceki seçimden kalan gizlemeler sıfırlanır (cinsiyet/kombin değişmiş olabilir). */
      var eskiler = bedenKap.querySelectorAll('[data-bs-sec="beden"]');
      for (var e = 0; e < eskiler.length; e++) eskiler[e].hidden = false;
      var bu = ++bedenIstekNo;
      Promise.all(handleler.map(function (h) { return urunleriGetir(kokUrl, h); }))
        .then(function (listeler) {
          if (bu !== bedenIstekNo || aktif !== 'beden') return;
          var btnler = bedenKap.querySelectorAll('[data-bs-sec="beden"]');
          var gizlenecek = [];
          for (var i = 0; i < btnler.length; i++) {
            var tag = btnler[i].getAttribute('data-tag') || '';
            if (!tag) continue;
            var varMi = false;
            for (var l = 0; l < listeler.length && !varMi; l++) {
              var liste = listeler[l] || [];
              for (var j = 0; j < liste.length; j++) {
                var u = liste[j];
                if (!stokVar(u)) continue;
                if (kelime && !baslikVar(u.title, kelime)) continue;
                if (cinsTag && !tagVar(u.tags || [], cinsTag)) continue;
                if (bedenUyar(u, tag)) { varMi = true; break; }
              }
            }
            if (!varMi) gizlenecek.push(btnler[i]);
          }
          if (gizlenecek.length && gizlenecek.length < btnler.length) {
            for (var g = 0; g < gizlenecek.length; g++) gizlenecek[g].hidden = true;
          }
        });
    }

    /* Bir adımın gösterilmeye değer olup olmadığı — boş adım atlanır. */
    function adimGecerli(ad) {
      if (ad === 'sonuc') return true;
      if (ad === 'beden') return bedenListesi.length > 0;
      if (ad === 'sicaklik') return bantVar && kok.querySelectorAll('[data-bs-sec="sicaklik"]').length > 0;
      if (ad === 'kombin') return kombinleriHazirla() > 0;
      if (ad === 'model') return modelleriHazirla() > 0;
      if (ad === 'kategori') return kategorileriHazirla() > 0;
      if (ad === 'mevsim') return kok.querySelectorAll('[data-bs-sec="mevsim"]').length > 0;
      if (ad === 'cinsiyet') return kok.querySelectorAll('[data-bs-sec="cinsiyet"]').length > 0;
      return true;
    }

    /* Seçili dalın sırasında, verilen adımdan SONRAKİ ilk geçerli adım.
       'tip' verilirse dalın ilk adımından başlar; hiçbiri geçerli
       değilse sonuca düşer. */
    function sonrakiAdim(mevcut) {
      var sira = DAL_SIRASI[secim.dal] || DAL_SIRASI.beden;
      var i;
      if (mevcut === 'tip') {
        i = 0;
      } else {
        i = sira.indexOf(mevcut);
        i = i < 0 ? 0 : i + 1;
      }
      for (; i < sira.length; i++) {
        if (adimGecerli(sira[i])) return sira[i];
      }
      return 'sonuc';
    }

    /* ---------- Adım gösterimi ---------- */

    function adimGoster(ad) {
      aktif = ad;
      for (var i = 0; i < adimlar.length; i++) {
        var el = adimlar[i];
        el.classList.toggle('is-aktif', el.getAttribute('data-bs-adim') === ad);
      }
      kok.classList.toggle('is-sonuc', ad === 'sonuc');
      if (ad === 'beden') bedenleriSuz();
      if (ad === 'sonuc') sonucYukle();
    }

    function ilerle(ad) {
      gecmis.push(aktif);
      adimGoster(ad);
    }

    function geriDon() {
      var onceki = gecmis.pop();
      adimGoster(onceki || 'tip');
    }

    function bastanBasla() {
      secim = bosSecim();
      bedenListesi = [];
      gecmis = [];
      if (bedenKap) bedenKap.innerHTML = '';
      var secililer = kok.querySelectorAll('.maiyko-bs__sec.is-secili');
      for (var i = 0; i < secililer.length; i++) secililer[i].classList.remove('is-secili');
      gorselAyarla(varsayilanGorsel);
      adimGoster('tip');
    }

    /* Yumuşak geçiş: yeni görsel önden yüklenir, sonra takas edilir. */
    function gorselAyarla(kaynak) {
      if (!gorselEl) return;
      var yeni = kaynak || varsayilanGorsel;
      if (!yeni) {
        gorselEl.hidden = true;
        return;
      }
      if (gorselEl.getAttribute('src') === yeni) {
        gorselEl.hidden = false;
        return;
      }
      var takas = function () {
        gorselEl.src = yeni;
        gorselEl.hidden = false;
        if (oval) {
          window.requestAnimationFrame(function () {
            oval.classList.remove('is-degisiyor');
          });
        }
      };
      if (oval) oval.classList.add('is-degisiyor');
      var on = new Image();
      on.onload = takas;
      on.onerror = takas;
      on.src = yeni;
      /* Görsel önbellekteyse onload gecikmesin diye emniyet zamanlayıcısı. */
      window.setTimeout(function () {
        if (oval && oval.classList.contains('is-degisiyor')) takas();
      }, 400);
    }

    /* Seçenek kendi görselini taşıyorsa değiştir, taşımıyorsa sondakini koru. */
    function gorselDenemesi(btn) {
      var g = btn.getAttribute('data-gorsel');
      if (g) gorselAyarla(g);
    }

    /* ---------- Sonuç ---------- */

    /* Sonuçta kullanılacak koleksiyon handle'ları (1 ya da 2 adet). */
    function aktifHandleler() {
      var liste = [];
      if (secim.dal === 'uyku' && secim.kombin) {
        if (secim.kombin.h1) liste.push(secim.kombin.h1);
        if (secim.kombin.h2) liste.push(secim.kombin.h2);
      } else if (secim.dal === 'ayakkabi' && secim.kategori && secim.kategori.handle) {
        liste.push(secim.kategori.handle);
      } else if (secim.dal === 'model' && secim.model && secim.model.handle) {
        liste.push(secim.model.handle);
      }
      if (!liste.length && secim.tip && secim.tip.handle) liste.push(secim.tip.handle);
      return liste;
    }

    /* Kart altındaki küçük bilgi satırı. */
    function altSatir() {
      var parcalar = [];
      if (secim.beden && secim.beden.etiket) parcalar.push(secim.beden.etiket);
      if (secim.cinsiyet && secim.cinsiyet.etiket) parcalar.push(secim.cinsiyet.etiket);
      return parcalar.join(' · ');
    }

    function kartOlustur(urun, alt) {
      var a = document.createElement('a');
      a.className = 'maiyko-bs__kart';
      a.href = kokDuzelt(kokUrl) + 'products/' + urun.handle;

      var kutu = document.createElement('span');
      kutu.className = 'maiyko-bs__kartgorsel';
      var src = urunGorseli(urun);
      if (src) {
        var img = document.createElement('img');
        img.src = src;
        img.alt = urun.title || '';
        img.loading = 'lazy';
        img.width = 600;
        img.height = 800;
        kutu.appendChild(img);
      }
      a.appendChild(kutu);

      var ad = document.createElement('span');
      ad.className = 'maiyko-bs__kartad';
      ad.textContent = urun.title || '';
      a.appendChild(ad);

      if (alt) {
        var altEl = document.createElement('span');
        altEl.className = 'maiyko-bs__kartalt';
        altEl.textContent = alt;
        a.appendChild(altEl);
      }

      if (fiyatGoster) {
        var yazi = fiyatYaz(urunFiyati(urun));
        if (yazi) {
          var f = document.createElement('span');
          f.className = 'maiyko-bs__kartfiyat';
          f.textContent = yazi;
          a.appendChild(f);
        }
      }

      return a;
    }

    function durumYaz(metin) {
      if (!durumEl) return;
      if (metin) {
        durumEl.textContent = metin;
        durumEl.hidden = false;
      } else {
        durumEl.textContent = '';
        durumEl.hidden = true;
      }
    }

    function sonucYukle() {
      if (!gridEl) return;

      var handleler = aktifHandleler();

      if (tumuEl) {
        if (handleler.length) {
          tumuEl.href = koleksiyonKok.replace(/\/$/, '') + '/' + handleler[0];
          tumuEl.hidden = false;
        } else {
          tumuEl.hidden = true;
        }
      }

      gridEl.innerHTML = '';

      if (!handleler.length) {
        durumYaz(metinBos);
        return;
      }

      durumYaz(metinYukleniyor);

      /* İki koleksiyonlu kombinde her birinden 2'şer, tekte 4 ürün. */
      var basina = handleler.length > 1 ? 2 : 4;
      var kelime = secim.dal === 'model' && secim.model ? secim.model.kelime : '';
      var cinsTag = secim.cinsiyet ? secim.cinsiyet.tag : '';
      var bedenTag = secim.beden ? secim.beden.tag : '';
      var bu = ++istekNo;

      var istekler = handleler.map(function (h) {
        return urunleriGetir(kokUrl, h);
      });

      Promise.all(istekler)
        .then(function (listeler) {
          if (bu !== istekNo) return; /* daha yeni bir seçim var */

          var secilenler = [];
          var gorulen = {};
          for (var i = 0; i < listeler.length; i++) {
            var pay = suz(listeler[i], kelime, cinsTag, bedenTag, basina);
            var eklenen = 0;
            for (var j = 0; j < pay.length && eklenen < basina; j++) {
              var anahtar = pay[j].handle || String(pay[j].id);
              if (gorulen[anahtar]) continue; /* iki koleksiyonda da varsa bir kez */
              gorulen[anahtar] = true;
              secilenler.push(pay[j]);
              eklenen++;
            }
          }

          gridEl.innerHTML = '';
          if (!secilenler.length) {
            /* Koleksiyonlarda ürün VAR ama stok filtresi hepsini elediyse
               genel "bulamadık" yerine stok-tükendi mesajı gösterilir. */
            var hamVar = false;
            for (var h = 0; h < listeler.length; h++) {
              if (listeler[h] && listeler[h].length) { hamVar = true; break; }
            }
            durumYaz(hamVar ? metinStok : metinBos);
            return;
          }
          durumYaz('');
          var alt = altSatir();
          var parca = document.createDocumentFragment();
          for (var k = 0; k < secilenler.length && k < 4; k++) {
            parca.appendChild(kartOlustur(secilenler[k], alt));
          }
          gridEl.appendChild(parca);
        })
        .catch(function () {
          if (bu !== istekNo) return;
          gridEl.innerHTML = '';
          durumYaz(metinBos);
        });
    }

    /* ---------- Tıklama yönlendirmesi ---------- */

    kok.addEventListener('click', function (olay) {
      var hedef = olay.target;
      if (!hedef || !hedef.closest) return;

      if (hedef.closest('[data-bs-bastan]')) {
        olay.preventDefault();
        bastanBasla();
        return;
      }
      if (hedef.closest('[data-bs-geri]')) {
        olay.preventDefault();
        geriDon();
        return;
      }

      var btn = hedef.closest('[data-bs-sec]');
      if (!btn || !kok.contains(btn)) return;
      olay.preventDefault();

      /* "Yakında" seçenekleri görünür ama seçilemez. */
      if (btn.getAttribute('data-pasif') === '1' || btn.classList.contains('is-pasif')) return;

      var tur = btn.getAttribute('data-bs-sec');
      var kap = btn.parentNode;
      if (kap) {
        var kardesler = kap.querySelectorAll('.maiyko-bs__sec');
        for (var i = 0; i < kardesler.length; i++) kardesler[i].classList.remove('is-secili');
      }
      btn.classList.add('is-secili');

      if (tur === 'tip') {
        /* Yeni tip = yeni dal; alt seçimler sıfırlanır. */
        var altSecimler = bosSecim();
        altSecimler.dal = btn.getAttribute('data-dal') || 'beden';
        altSecimler.tip = {
          handle: btn.getAttribute('data-koleksiyon-handle') || '',
          etiket: btn.getAttribute('data-etiket') || '',
          modelSoru: btn.getAttribute('data-model-soru') || ''
        };
        secim = altSecimler;
        bedenListesi = bedenleriCoz(jsonCoz(btn.getAttribute('data-bedenler'), ''));
        bedenleriHazirla();
        gorselDenemesi(btn);
        ilerle(sonrakiAdim('tip'));
        return;
      }

      if (tur === 'model') {
        secim.model = {
          handle: btn.getAttribute('data-koleksiyon-handle') || '',
          kelime: btn.getAttribute('data-kelime') || '',
          etiket: btn.getAttribute('data-etiket') || ''
        };
        gorselDenemesi(btn);
        ilerle(sonrakiAdim('model'));
        return;
      }

      if (tur === 'sicaklik') {
        secim.sicaklik = {
          bant: btn.getAttribute('data-bant') || '',
          etiket: btn.getAttribute('data-etiket') || ''
        };
        secim.kombin = null;
        gorselDenemesi(btn);
        ilerle(sonrakiAdim('sicaklik'));
        return;
      }

      if (tur === 'kombin') {
        secim.kombin = {
          h1: btn.getAttribute('data-h1') || '',
          h2: btn.getAttribute('data-h2') || '',
          etiket: btn.getAttribute('data-etiket') || ''
        };
        gorselDenemesi(btn);
        ilerle(sonrakiAdim('kombin'));
        return;
      }

      if (tur === 'mevsim') {
        secim.mevsim = {
          deger: btn.getAttribute('data-mevsim') || '',
          etiket: btn.getAttribute('data-etiket') || ''
        };
        secim.kategori = null;
        gorselDenemesi(btn);
        ilerle(sonrakiAdim('mevsim'));
        return;
      }

      if (tur === 'kategori') {
        secim.kategori = {
          handle: btn.getAttribute('data-koleksiyon-handle') || '',
          etiket: btn.getAttribute('data-etiket') || ''
        };
        gorselDenemesi(btn);
        ilerle(sonrakiAdim('kategori'));
        return;
      }

      if (tur === 'cinsiyet') {
        secim.cinsiyet = {
          tag: btn.getAttribute('data-tag') || '',
          etiket: btn.getAttribute('data-etiket') || ''
        };
        gorselDenemesi(btn);
        ilerle(sonrakiAdim('cinsiyet'));
        return;
      }

      if (tur === 'beden') {
        secim.beden = {
          tag: btn.getAttribute('data-tag') || '',
          etiket: btn.getAttribute('data-etiket') || ''
        };
        ilerle(sonrakiAdim('beden'));
      }
    });

    /* Tema editöründe blok seçilince o adıma atlanır. Blok başka bir tipe
       bağlı olabileceği için önce tüm seçenekler açılır. */
    function editorAdim(ad) {
      var gizliler = kok.querySelectorAll('[data-bs-sec="model"], [data-bs-sec="kategori"]');
      for (var i = 0; i < gizliler.length; i++) gizliler[i].hidden = false;
      if (ad === 'kombin') {
        var kaplar = kok.querySelectorAll('[data-bs-kombin-bant]');
        for (var k = 0; k < kaplar.length; k++) kaplar[k].hidden = k !== 0;
      }
      adimGoster(ad);
    }

    kok.__bsApi = { adimGoster: adimGoster, editorAdim: editorAdim, bastanBasla: bastanBasla };

    adimGoster('tip');
  }

  function hepsiniKur(kapsam) {
    var alan = kapsam && kapsam.querySelectorAll ? kapsam : document;
    var liste = alan.querySelectorAll('[data-maiyko-bs]');
    for (var i = 0; i < liste.length; i++) kur(liste[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      hepsiniKur(document);
    });
  } else {
    hepsiniKur(document);
  }

  /* ---------- Tema editörü ---------- */

  document.addEventListener('shopify:section:load', function (olay) {
    hepsiniKur(olay.target);
  });

  document.addEventListener('shopify:block:select', function (olay) {
    var btn = olay.target;
    if (!btn || !btn.closest) return;
    var kok = btn.closest('[data-maiyko-bs]');
    if (!kok || !kok.__bsApi) return;
    var tur = btn.getAttribute && btn.getAttribute('data-bs-sec');
    if (!tur) return;
    kok.__bsApi.editorAdim(tur);
  });
})();
